import { useState, useEffect } from "react";
import { saveBankDetails, getAllCompanyCodes } from "../Api/BankMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo"; 

const BankMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [companyCodes, setCompanyCodes] = useState([]);

  const [bankData, setBankData] = useState({
    code: "",
    description: "",
    companyCode: ""
  });

  useEffect(() => {
    const fetchCompanyCodes = async () => {
      try {
        const data = await getAllCompanyCodes();
        setCompanyCodes(data);
      } catch (error) {
        toast.error("Failed to load company codes");
      }
    };
    fetchCompanyCodes();
  }, []);

  const handleChange = (e) => {
    setBankData({ ...bankData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveBankDetails(bankData);
      toast.success("Bank Added Successfully");
      setBankData({ code: "", description: "", companyCode: "" });
      navigate("/viewBankMaster"); 
    } catch (error) {
      toast.error("Error adding bank!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Bank Master</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Bank Code <span className="text-red">**</span></Form.Label>
                    <Form.Control type="text" name="code" value={bankData.code} onChange={handleChange} required />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Description <span className="text-red">**</span></Form.Label>
                    <Form.Control type="text" name="description" value={bankData.description} onChange={handleChange} required />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Company Code <span className="text-red">**</span></Form.Label>
                    <Form.Select 
                      name="companyCode" 
                      value={bankData.companyCode} 
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Company Code</option>
                      {companyCodes.map((company) => (
                        <option key={company.companyCode} value={company.companyCode}>
                          {company.companyCode} - {company.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Bank
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default BankMaster;